import { render } from "./ShopDetail.vue?vue&type=template&id=1a14ae3c&scoped=true"
import script from "./ShopDetail.vue?vue&type=script&lang=js"
export * from "./ShopDetail.vue?vue&type=script&lang=js"

import "./ShopDetail.vue?vue&type=style&index=0&id=1a14ae3c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a14ae3c"]])

export default __exports__